import { TFunction } from 'react-i18next';
import { UseFormGetValues } from 'react-hook-form';
import { ValidationOptions } from '../../../types/form';

export function transformValidationOptions<TFieldValues>(
  t: TFunction,
  validation: ValidationOptions<TFieldValues> = {},
  getValues?: UseFormGetValues<TFieldValues>,
) {
  const rules = { ...validation };

  if (rules.required === true) {
    rules.required = t('site.pricing.validation.error.code.REQUIRED');
  }

  if (typeof rules.min === 'number') {
    rules.min = {
      value: rules.min,
      message: t('site.pricing.validation.error.code.INVALID_MIN_VALUE', {
        0: rules.min,
      }),
    };
  }

  if (typeof rules.max === 'number') {
    rules.max = {
      value: rules.max,
      message: t('site.pricing.validation.error.code.INVALID_MAX_VALUE', {
        0: rules.max,
      }),
    };
  }

  if (rules.match && rules.match.name && getValues) {
    const fieldName = rules.match.name;
    const errorMessage = rules.match.message;

    rules.validate = {
      isMatch(value) {
        return getValues(fieldName) === value || errorMessage || false;
      },
      ...rules.validate,
    };
  }

  return rules;
}
